// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"950":"8fce1666","9870":"8fce1666"}[chunkId] + ".chunk.css";
};